import React, { useState , useEffect, useContext} from 'react';
import '../css/sidebar.css';


import Logo from '../images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Link, useNavigate } from 'react-router-dom'
import { ShareContext } from '../context/sharecontext';



function IdHomeTop(props) {

    
    useEffect(() => {
      
     }, []);

     const navigate = useNavigate();
     const onLogin=()=>{
         navigate('/login');
     }
  return (
    <div className='header'>
            <img src={Logo}/>
            <div>
                <ul>
                    <li className={props.active=='home'?'underline':''}><Link to={"/"}>Home</Link> </li>
                    <li className={props.active=='about'?'underline':''}> <Link to={"/about"}>About</Link></li>
                    <li className={props.active=='howitwork'?'underline':''}> <Link to={"/howitwork"}>How its works</Link></li>
                    <li className={props.active=='verifyapi'?'underline':''}> <Link to={"/verifyapi"}>API</Link></li>
                    <li className={props.active=='contact'?'underline':''}> <Link to={"/contact"}>Contact Us</Link></li>
                    <li><button className='greenbutton' onClick={onLogin}>Log In</button></li>
                </ul>
            </div>
       </div>
  )
}

export default IdHomeTop